<template>
  <Head :title="t('institutions')" />
  <s-page-block>
    <s-page-header :heading="t('institutions')" />

    <s-form-inline
      id="searchText"
      icon="magnify"
      class="mt-5 mb-4"
      :placeholder="t('search.placeholder')"
      :submitLabel="$t('search.label')"
      v-model="search"
    />

    <s-data-table
      :data="filteredInstitutions"
      :columns="[
        {
          key: 'abbreviation',
          label: t('abbreviation'),
          th: {class: 'w-0'},
        },
        {key: 'name', label: t('name')},
      ]"
    >
      <template #td:abbreviation="{abbreviation, id}">
        <s-link :href="route('institutions.show', {institution: id})" class="link-subtle">
          {{ abbreviation }}
        </s-link>
      </template>
      <template #td:name="{name, id}">
        <s-link :href="route('institutions.show', {institution: id})" class="link-subtle">
          {{ name }}
        </s-link>
      </template>
    </s-data-table>
  </s-page-block>
</template>

<script setup lang="ts">
import SPageBlock from '../../design-system/SPageBlock.vue';
import SPageHeader from '../../design-system/SPageHeader.vue';
import {Institution} from '../../types/entities/institution';
import {useI18n} from 'vue-i18n';
import {ref, computed} from 'vue';
import SFormInline from '../../design-system/SFormInline.vue';
import SDataTable from '../../design-system/SDataTable.vue';
import SLink from '../../components/SLink.vue';
import {route} from 'ziggy-js';
import {Head} from '@inertiajs/vue3';

const {institutions} = defineProps<{
  institutions: Institution[];
  can: {
    create: boolean;
  };
}>();

const {t} = useI18n({
  useScope: 'local',
  inheritLocale: true,
});

const search = ref<string>('');

const filteredInstitutions = computed(() => {
  return institutions.filter((institution) =>
    institution.name.toLowerCase().includes(search.value.toLowerCase())
  );
});
</script>
<i18n>
{
  "en": {
    "abbreviation": "Abbreviation",
    "name": "Name",
    "actions.view": "View"
  },
  "fr": {
    "abbreviation": "Abréviation",
    "name": "Nom",
    "actions.view": "Voir"
  }
}
</i18n>
